'use client';
import { createStyles, rem, getSize, keyframes } from '@s7/styles';

function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "                \n    0% {\n        clip-path: polygon(50% 50%,0 0,50% 0%,50% 0%,50% 0%,50% 0%,50% 0%);\n    }\n    12.5% {\n        clip-path: polygon(50% 50%,0 0,50% 0%,100% 0%,100% 0%,100% 0%,100% 0%);\n    }\n    25% {\n        clip-path: polygon(50% 50%,0 0,50% 0%,100% 0%,100% 100%,100% 100%,100% 100%);\n    }\n    50% {\n        clip-path: polygon(50% 50%,0 0,50% 0%,100% 0%,100% 100%,50% 100%,0% 100%);\n    }\n    62.5% {\n        clip-path: polygon(50% 50%,100%  0,100% 0%,100% 0%,100% 100%,50% 100%,0% 100%);\n    }\n    75% {\n        clip-path: polygon(50% 50%,100% 100%,100% 100%,100% 100%,100% 100%,50% 100%,0% 100%);\n    }\n    100% {\n        clip-path: polygon(50% 50%,50% 100%,50% 100%,50% 100%,50% 100%,50% 100%,0% 100%);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal_loose([
        "\n    0% { \n        transform: scaleY(1)  rotate(0deg);\n    }\n    49.99% {\n         transform: scaleY(1)  rotate(135deg);\n    }\n    50% { \n        transform: scaleY(-1) rotate(0deg);\n    }\n    100% { \n        transform: scaleY(-1) rotate(-135deg);\n    }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var animationStart = keyframes(_templateObject());
var animationEnd = keyframes(_templateObject1());
var sizes = {
    xl1: 40,
    lg1: 32,
    md1: 20,
    sm1: 16
};
var borderWidths = {
    xl1: 5,
    lg1: 4,
    md1: 3,
    sm1: 2
};
var useStyles = createStyles(function(param, param1) {
    var _param_fn = param.fn, primaryShade = _param_fn.primaryShade, themeColor = _param_fn.themeColor;
    var color = param1.color, size = param1.size;
    var _size = rem(getSize({
        size: size,
        sizes: sizes
    }));
    var base = color ? primaryShade(themeColor(color)) : "currentColor";
    var _borderWidths_size;
    var borderWidth = rem((_borderWidths_size = borderWidths[size]) != null ? _borderWidths_size : borderWidths.md1);
    return {
        root: {
            width: _size,
            height: _size,
            borderRadius: "50%",
            border: borderWidth + " solid " + base,
            backgroundColor: "transparent !important",
            animation: animationStart + " 0.8s infinite linear alternate, " + animationEnd + " 1.6s infinite linear"
        }
    };
});

export { borderWidths, useStyles as default, sizes };
